import React, { useRef, useLayoutEffect, useState } from 'react';
import ExampleTheme from "./themes/ExampleTheme";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin";
import {HashtagPlugin} from '@lexical/react/LexicalHashtagPlugin';
import ToolbarPlugin from "./plugins/ToolbarPlugin";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import TreeViewPlugin from './plugins/TreeViewPlugin';
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table";
import { ListItemNode, ListNode } from "@lexical/list";
import { HashtagNode } from "@lexical/hashtag";
import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { MarkdownShortcutPlugin } from "@lexical/react/LexicalMarkdownShortcutPlugin";
import { TRANSFORMERS } from "@lexical/markdown";
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {TextField} from '@mui/material';

import {$getRoot, $getSelection, CONTROLLED_TEXT_INSERTION_COMMAND, EditorState} from 'lexical';
import {LexicalComposer} from '@lexical/react/LexicalComposer';
import {HistoryPlugin} from '@lexical/react/LexicalHistoryPlugin';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';

import CodeHighlightPlugin from "./plugins/CodeHighlightPlugin";
import prepopulatedText from "../../texts/CanceledFlight_Rejection_1";

import { Button, Grid } from '@mui/material';
import TagEditorPlugin from './plugins/TagEditorPlugin';
import Item from '@mui/material/Grid';
import {supabase } from "../../lib/supabase";
import AlertDialog from '../dialog/AlertDialog';
import { margin } from '@mui/system';

const EditorManager = (props) => {  
  console.log('EDITOR PROPS')
  //console.log(props);
  //const [tmpEditorState, setTmpEditorState] = useState(null);
  const [editorStateInit, setEditorState] = useState('');
  const [userToLog, setUserToLogState] = useState(props.user || null);
  console.log(userToLog);
  const [templateId, setTemplateid] = useState(props.templateId || '-1');
  const [templateLanguage, setTemplateLanguage] = useState(props.templateLanguage || '');
  
  const [templateName, setTemplateName] = useState(sessionStorage.getItem('templateName') || '');  
  const [templateShortDescription, setTemplateShortDescription] = useState(sessionStorage.getItem('templateShortDescription')|| '');  
  const [templateLongDescription, setTemplateLongDescription] = useState(sessionStorage.getItem('templateLongDescription') || '');    
  const [templateNumber, setTemplateNumber] = useState(sessionStorage.getItem('templateNumber') || '');  
  const [templateCountries, setTemplateCountriesLimitation] = useState(sessionStorage.getItem('templateCountriesLimitation') || null);  
  

  const content = sessionStorage.getItem('messageEditor');
  const placeholdersConfigJson = sessionStorage.getItem('templatePlaceholders');
  //const myInitialEditorState = editorStateInit;
  //const myInitialEditorState = '{"root":{"children":[{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"Dear {{CUSTOMER_NAME}},","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"Thank you for contacting Wizz Air Customer Service Department. We see that you were not a passenger in this booking, and you submitted this claim as an assignee based on your assignment agreement with the passenger.","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"I would like to inform you that we have concluded that compensation is due in accordance with the EU Regulation 261/2004 regarding your claim with reference number","type":"text","version":1},{"detail":0,"format":2,"mode":"normal","style":"","text":" {{CASE_ID}}","type":"text","version":1},{"detail":0,"format":0,"mode":"normal","style":"","text":". ","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"Please be informed that","type":"text","version":1},{"detail":0,"format":1,"mode":"normal","style":"","text":" we will transfer the amount of {{COMPENSATION_AMOUNT}} for compensation","type":"text","version":1},{"detail":0,"format":0,"mode":"normal","style":"","text":" in accordance with the EU Regulation 261/2004 to the bank account indicated by you. Please be advised that the handling of such assigned claims due to their nature, results in additional expenses for us. According to the Hungarian Civil Code 6:200. § and our General Conditions of Carriage which is under Hungarian law, such expenses shall be covered by the assignor and assignee jointly.","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"Therefore, we have deducted the Assignment Administration Fee from the compensation payment by way of setting off our incurred expenses against your claim in line with the applicable legal provisions. The amount of Assignment Administration Fee is 50 EUR. The bank transfer process has been initiated, and ","type":"text","version":1},{"detail":0,"format":1,"mode":"normal","style":"","text":"it will be completed within 14 business days","type":"text","version":1},{"detail":0,"format":0,"mode":"normal","style":"","text":".","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"Should you have any additional questions or concerns, I remain at your disposal.","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"Wizz Air wishes you a good day.","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"Kind regards,","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1},{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"{{AGENT_NAME}}","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1}],"direction":"ltr","format":"","indent":0,"type":"root","version":1}}';
  const editorConfig = {  
    editorState: content,
    theme: ExampleTheme,
    namespace: 'messageEditor',
    // Handling of errors during update
    onError(error) {
      throw error;
    },
    // Any custom nodes go here
    nodes: [
      HeadingNode,
      ListNode,
      ListItemNode,
      QuoteNode,
      CodeNode,
      CodeHighlightNode,
      TableNode,
      TableCellNode,
      TableRowNode,
      AutoLinkNode,
      HashtagNode, 
      LinkNode
    ]
  };

  function Placeholder() {
    return (
      <div className="editor-placeholder">
        Write down some comprehensive response for your air passenger ...
      </div>
    );
  }

  //tato funkcia sa vola vzdy ked napises textik do editora 
  //da sa sem napriklad dorobit kontrola pravopisu 
  //alebo kontrola zlych slov
  function myChange(editorState) {
    editorStateRef.current = editorState
    // editorState.read(() => {
    //   const root = $getRoot();
    //   const selection = $getSelection();

    //   console.log(root, selection);
    // });
}

  function handleNuberBoxChange(event){
    setTemplateNumber(event.target.value);
  }

  function handleTemplateNameBoxChange(event){
    setTemplateName(event.target.value);
  }
  function handleShortDescriptionBoxChange(event){
    setTemplateShortDescription(event.target.value);
  }
  
  function handleLongDescriptionBoxChange(event){
    setTemplateLongDescription(event.target.value);
  }

  function handleCountriesBoxChange(event){
    setTemplateCountriesLimitation(event.target.value);
  }

  // tu mozes dorobit funkcionalitu ukladania do databazy v nejakom inom editor2
  //ked budu aj ine vstupne atributy
  const saveContent = async (contentString) => {

    console.log(contentString);  
    console.log("Going to edit this language:",templateLanguage);  
    if (templateLanguage == 'EN')
    {
        const { data, error } = await supabase.from('templates').update({ 'EN': contentString, 'sc_number': templateNumber, 'sc_name': templateName, 'sc_shortDescription': templateShortDescription, 'sc_instruction': templateLongDescription, 'jurisdiction_restricting_useage': templateCountries }).eq('id', templateId);
        console.log(data, error);
    }

    if (templateLanguage == 'PL')
    {
      const { data, error } = await supabase.from('templates').update({ 'PL': contentString, 'sc_number': templateNumber, 'sc_name': templateName, 'sc_shortDescription': templateShortDescription, 'sc_instruction': templateLongDescription, 'jurisdiction_restricting_useage': templateCountries }).eq('id', templateId);
      console.log(data, error);
    }

    if (templateLanguage == 'IT')
    {
      const { data, error } = await supabase.from('templates').update({ 'IT': contentString, 'sc_number': templateNumber, 'sc_name': templateName, 'sc_shortDescription': templateShortDescription, 'sc_instruction': templateLongDescription, 'jurisdiction_restricting_useage': templateCountries }).eq('id', templateId);
      console.log(data, error);
    }        
  }

  const TestValues = async () => {    
    console.log('templateId:', templateId);
    
    //const { data, error } = await supabase.from('templates').delete().eq('id', templateId);  
    //console.log(data, error);    
  }

  const editorStateRef = useRef();

  return (
    <LexicalComposer initialConfig={editorConfig} >
      <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <Item>         
                <TagEditorPlugin user={userToLog} templateId={templateId}/>                                      
                </Item>
            </Grid>
            <Grid item xs={12} md={8} spacing={2}>
                <Item sx={{
                            width: 750,
                            maxWidth: '100%',                            
                            
                            padding: '10px'
                          }}>
                   <TextField required fullWidth id="templateNumberBox" label="Template SC Number:" width="100%" variant="outlined" defaultValue={templateNumber} onChange={handleNuberBoxChange}/>              
                </Item>
                <Item sx={{
                            width: 750,
                            maxWidth: '100%',                            

                            padding: '10px'
                          }}>
                   <TextField required fullWidth id="templateNameBox" label="Template name:" width="100%" variant="outlined" defaultValue={templateName} onChange={handleTemplateNameBoxChange}/>
                </Item>
                <Item sx={{
                            width: 750,
                            maxWidth: '100%',                            

                            padding: '10px'
                          }}>
                   <TextField required fullWidth id="templateShortDescriptionBox" label="Short Description:" width="100%" variant="outlined" defaultValue={templateShortDescription} onChange={handleShortDescriptionBoxChange}/>                
                </Item>
                <Item sx={{
                            width: 750,
                            maxWidth: '100%',                            
                            padding: '10px'
                          }}>
                   <TextField required fullWidth multiline maxRows={4} id="templateLongDescriptionBox" label="Long Description:" width="100%" variant="outlined" defaultValue={templateLongDescription} onChange={handleLongDescriptionBoxChange}/>                   
                </Item>
                <Item sx={{
                            width: 750,
                            maxWidth: '100%',                            
                            padding: '10px'
                          }}>
                   <TextField fullWidth id="negativeCountriesBox" label="Countries limitations:" width="100%" variant="outlined" defaultValue={templateCountries} onChange={handleCountriesBoxChange}/>                   
                </Item>
                <Item>                    
                    <div className="editor-container">
                    <ToolbarPlugin />
                    <div className="editor-inner">
                      <RichTextPlugin
                        contentEditable={<ContentEditable className="editor-input" />}
                        placeholder={<Placeholder />}                        
                      />          
                      <OnChangePlugin onChange={editorState => myChange(editorState)} />          
                      <Button variant="contained" label="Save" onClick={() => {
                          if (editorStateRef.current) {
                              saveContent(JSON.stringify(editorStateRef.current))                  
                          }
                        }}>SAVE
                      </Button>
                      <Button variant="contained" label="TEST" onClick={() => {
                          if (editorStateRef.current) {
                              TestValues(JSON.stringify(editorStateRef.current))                  
                          }
                        }}>TEST
                      </Button> 
                      <AlertDialog templateId={templateId} />                     
                      <AutoFocusPlugin />
                      <ListPlugin />
                      <LinkPlugin />
                      <HashtagPlugin />
                      <MarkdownShortcutPlugin transformers={TRANSFORMERS} />
                      <CodeHighlightPlugin />
                      <TreeViewPlugin />
                    </div>        
                  </div>            
                </Item>
            </Grid>
         </Grid>
    </LexicalComposer>  
  );
}
export default EditorManager;